import { useMutation } from '@tanstack/react-query';
import type { DeletePensioenbijEventsArgs } from '../../../Domain/Tools/Services';
import { toolsServices } from '../../../Domain/Tools/Services';

const mutationFn = (data: DeletePensioenbijEventsArgs) => {
  return toolsServices.deletePensioenbijEvents(data);
};

export const useDeletePensioenbijMutation = () => {
  return useMutation<unknown, unknown, DeletePensioenbijEventsArgs>(mutationFn);
};
